/**
 * Converts the total minutes into a string format of hours and minutes.
 * @param totalMinutes - The minutes value to convert
 * @returns The converted totalMinutes into a human readable string
 */
export function minutesToHoursAndMinutes(totalMinutes: number) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const hoursDisplay = hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}` : '';
  const minutesDisplay = minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : '';

  return [hoursDisplay, minutesDisplay].filter(Boolean).join(' ');
}
